import MenuFeatures from "containers/MenuFeatures"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { getLandingDropdownList, getLandingSetup } from "store/actions"
import { buildListDropdownOption, buildSingleItemDropdownOption } from "./utils"

const MenuFeaturesTab = ({
  landingDropdownList,
  getLandingDropdownList,
  landingSetup,
  getLandingSetup,
  vendorId,
}) => {
  useEffect(() => {
    getLandingDropdownList({})
  }, [])

  const duplicatedListItems = [
    "countdown_clock",
    "polls",
    "surveys",
    "trivia_challenge",
    "lists",
    "documents",
    "custom_web_links",
    "calendar",
    "questionnaires",
    "booking_service",
    "view_bookings",
    "form_builders",
    "basic_content",
    "video_call",
    "media",
  ]

  const initDropdownValues = () => {
    let values = [...landingDropdownList]
    let dropdownValues = []

    landingSetup?.menu.forEach(item => {
      if (
        values.indexOf(item.machine_name) !== -1 &&
        duplicatedListItems.indexOf(item.machine_name) === -1
      ) {
        let index = values.indexOf(item.machine_name)
        values.splice(index, 1)
      }
    })

    values.forEach(item => {
      const listItem = buildListDropdownOption(item)
      if (listItem) {
        dropdownValues.push(listItem)
      }
      const singleItem = buildSingleItemDropdownOption(item)
      if (singleItem) {
        dropdownValues.push(singleItem)
      }
    })

    return dropdownValues.sort((a, b) =>
      a.text > b.text ? 1 : a.text < b.text ? -1 : 0
    )
  }

  return (
    <MenuFeatures
      featureDropdownList={initDropdownValues().map(option => ({
        value: option.machine_name,
        label: option.text,
        type: option.type === "list" ? 0 : 1,
      }))}
      menuList={landingSetup?.menu || []}
      updateMenuList={() => {
        getLandingSetup({ vendorId: vendorId })
      }}
      landingSetup={landingSetup}
      design={landingSetup}
    />
  )
}

const mapStateToProps = state => ({
  landingSetup: state.LandingScreen.landingSetup,
  landingDropdownList: state.LandingScreen.landingDropdownList,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getLandingDropdownList: values => dispatch(getLandingDropdownList(values)),
  getLandingSetup: values => dispatch(getLandingSetup(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MenuFeaturesTab)
